import React from 'react';
import isMobile from '../mobile'
function Footer() {
    return (              
        <footer id="footer" role="contentinfo" className={isMobile()}>
          <div className="container">
              <div id="block-block-8" className="block block-block connect-with-us-block">
                  <h2>Take a tour:</h2>
                  <div className="content">
                      <ul>
                          <li className="col-1 first">
                              <a href="https://tours.asu.edu/downtown">Downtown Phoenix campus</a>
                          </li>
                          <li className="col-2">
                              <a href="https://tours.asu.edu/polytechnic">Polytechnic campus</a>
                          </li>
                          <li className="col-3">
                              <a href="https://tours.asu.edu/tempe">Tempe campus</a>
                          </li>
                          <li className="col-4">
                              <a href="https://tours.asu.edu/west">West campus</a>
                          </li>
                          <li className="col-5">
                              <a href="https://tours.asu.edu/havasu">Lake Havasu</a>
                          </li>
                      </ul>
                  </div>
              </div>
              <div id="block-block-13" className="block block-block fat-footer-block">
                  <div className="content">
                      <div className="contact-info">
                          <div className="microdata" itemScope="" itemType="http://schema.org/CollegeOrUniversity">
                              <a href="http://www.asu.edu" itemProp="url">
                                  <div itemProp="name">
                                      <strong>Arizona State University</strong>
                                  </div>
                              </a>
                              <div itemProp="description">Arizona State University is a top ranked research university in the greater Phoenix metropolitan area.</div>
                              <div itemProp="address" itemScope="" itemType="http://schema.org/PostalAddress">
                                  <ul>
                                      <li itemProp="addressLocality">Tempe</li>
                                      <li itemProp="addressRegion">AZ</li>
                                      <li itemProp="postalCode">85281</li>
                                      <li itemProp="telephone">
                                          <a href="tel:480-965-2100">480-965-2100</a>
                                      </li>
                                  </ul>
                              </div>
                              <div itemProp="hasMap" itemScope="" itemType="http://schema.org/Map">
                                  <link href="http://schema.org/VenueMap" itemProp="mapType"/>
                                  <a href="https://www.google.com/maps/place/Arizona+State+University,+Tempe+Campus/@33.42424,-111.928053,17z/data=!3m1!4b1!4m7!1m4!3m3!1s0x872b08db3b33540f:0x666e717f473c3033!2sArizona+State+University,+Tempe+Campus!3b1!3m1!1s0x872b08db3b33540f:0x666e717f473c3033" itemProp="url">Map</a>
                              </div>
                          </div>
                          <ul className="dgtl-mkting-101">
                              <li>
                                  <a href="http://www.facebook.com/arizonastateuniversity" title="Facebook">
                                      <span className="fa fa-facebook-square">
                                          <span className="sr-only">Facebook</span>
                                      </span>
                                  </a>
                              </li>
                              <li>
                                  <a href="http://www.twitter.com/asu" title="Twitter">
                                      <span className="fa fa-twitter-square">
                                          <span className="sr-only">Twitter</span>
                                      </span>
                                  </a>
                              </li>
                              <li>
                                  <a href="http://www.linkedin.com/company/arizona-state-university" title="LinkedIn">
                                      <span className="fa fa-linkedin-square">
                                          <span className="sr-only">LinkedIn</span>
                                      </span>
                                  </a>
                              </li>
                              <li>
                                  <a href="http://www.youtube.com/asu" title="YouTube">
                                      <span className="fa fa-youtube-square">
                                          <span className="sr-only">YouTube</span>
                                      </span>
                                  </a>
                              </li>
                              <li>
                                  <a href="https://www.instagram.com/arizonastateuniversity/" title="Instagram">
                                      <span className="fa fa-instagram">
                                          <span className="sr-only">Instagram</span>
                                      </span>
                                  </a>
                              </li>
                              <li>
                                  <a href="https://www.pinterest.com/arizonastateuniversity/" title="Pinterest">
                                      <span className="fa fa-pinterest-square">
                                          <span className="sr-only">Pinterest</span>
                                      </span>
                                  </a>
                              </li>
                          </ul>
                      </div>
                      <ul className="footer-menu">
                          <li className="col-1 first">
                              <a href="/?feature=home">Home</a>
                          </li>
                          <li className="col-2">
                              <a href="/?feature=newsevents">News/Events</a>
                          </li>
                          <li className="col-3">
                              <a href="/?feature=academics">Academics</a>
                          </li>
                          <li className="col-4">
                              <a href="/?feature=research">Research</a>
                          </li>
                          <li className="col-5">
                              <a href="/?feature=athletics">Athletics</a>
                          </li>
                          <li className="col-6">
                              <a href="/?feature=alumni">Alumni</a>
                          </li>
                          <li className="col-7">
                              <a href="/?feature=giving">Giving</a>
                          </li>
                          <li className="col-8">
                              <a href="/?feature=president">President</a>
                          </li>
                          <li className="col-9 last">
                              <a href="https://www.asu.edu/about">About ASU</a>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
          <div id="block-asu-brand-asu-brand-footer" className="block block-asu-brand">
              <div className="content">
                  <div id="innovation-footer">
                      <div id="innovation-bar">
                          <div className="innovation-top">
                              <div className="innovation-status">
                                  <a href="https://www.asu.edu/rankings">
                                      <span>ASU is No.1 in the U.S. for innovation</span>
                                  </a>
                              </div>
                              <div className="innovation-hidden">
                                  <a href="https://www.asu.edu/rankings">
                                      <img loading="lazy" src="//www.asu.edu/asuthemes/4.9/assets/ASU-number-1-innovation-best-colleges.png" alt="Best Colleges U.S. News Most Innovative 2020"/>
                                  </a>
                              </div>
                          </div>
                      </div>
                      <div className="footer-menu">
                          <ul className="default">
                              <li className="innovation-mobile-only">
                                  <a href="https://my.asu.edu/">My ASU</a>
                              </li>
                              <li>
                                  <a href="https://www.asu.edu/copyright/">Copyright and Trademark</a>
                              </li>
                              <li>
                                  <a href="https://www.asu.edu/accessibility/">Accessibility</a>
                              </li>
                              <li>
                                  <a href="https://www.asu.edu/privacy/">Privacy</a>
                              </li>
                              <li>
                                  <a href="https://www.asu.edu/tou/">Terms of Use</a>
                              </li>
                              <li>
                                  <a href="https://www.asu.edu/asujobs">Jobs</a>
                              </li>
                              <li>
                                  <a href="https://www.asu.edu/emergency/">Emergency</a>
                              </li>
                              <li className="no-border">
                                  <a href="https://www.asu.edu/contactasu/">Contact ASU</a>
                              </li>
                          </ul>
                      </div>
                  </div>
              </div>
          </div>
      </footer>
        );
}
  
export default Footer;